import { Group, Radio, Stack, Text } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import PackageDropdown from '../../../../../../../../../components/package-dropdown/container';
import ShippingServiceSelector from '../../../../../../../../../components/shipping-service-selector';

import classes from './you-assign-service.module.less';
import messages from './messages';

const ASSIGN_SERVICE = 'assignService';

type YouAssignServiceProps = {
  isSelected: boolean;
  onOptionChange: () => void;
  onServiceSelected: () => void;
  onPackageSelected: (packageType: { packageTypeId: string; carrierId?: string } | undefined) => void;
  selectedItemName: string;
  serviceGroups: unknown[];
  packageFilter: (pkg: Record<string, unknown>) => boolean;
  selectedPackageKey?: string;
};

export const YouAssignService = ({
  isSelected,
  onOptionChange,
  onServiceSelected,
  onPackageSelected,
  selectedItemName,
  serviceGroups,
  packageFilter,
  selectedPackageKey,
}: YouAssignServiceProps) => (
  <Group align='flex-start'>
    <Radio onClick={onOptionChange} value={ASSIGN_SERVICE} />
    <Stack>
      <div>
        <Text size='sm'>
          <FormattedMessage {...messages.youAssignTheService} />
        </Text>
        <Text c='gray.6' size='xs'>
          <FormattedMessage {...messages.youAssignTheServiceDescription} />
        </Text>
      </div>

      {isSelected && (
        <>
          <div>
            <Text fw={500} size='sm'>
              <FormattedMessage {...messages.returnShippingMethod} />
            </Text>
            <ShippingServiceSelector
              defaultEmptyText={messages.sameAsOutbound}
              onSelected={onServiceSelected}
              selectedItemName={selectedItemName}
              serviceGroups={serviceGroups}
            />
          </div>

          <div className={classes['package-dropdown']}>
            <Text fw={500} size='sm'>
              <FormattedMessage {...messages.package} />
            </Text>
            <PackageDropdown
              className={classes['package-dropdown']}
              defaultEmptyText={<FormattedMessage {...messages.sameAsOutbound} />}
              dropdownMenuShouldHaveWidthOfButton
              onPackageSelected={onPackageSelected}
              packageFilter={packageFilter}
              selectedPackageKey={selectedPackageKey}
              showEmptyOption
              simpleToggler
              variant='form'
            />
          </div>
        </>
      )}
    </Stack>
  </Group>
);
